/**
 * A domain error: the request is refused because a business rule says so, not
 * because anything is broken. It carries a stable machine code (LFOC-REG-nnn
 * and similar, per docs/decisions.md) that a client can branch on and a
 * runbook can be searched by, an operator-facing message, the HTTP status a
 * router maps it to, and any structured details the caller needs to build
 * that message (a fund id, a date, an order id).
 */
export class DomainError extends Error {
  constructor(code, message, { status = 409, details = null } = {}) {
    super(message ?? code);
    this.name = 'DomainError';
    this.code = code;
    this.status = status;
    this.details = details;
  }
}
